import React, { useEffect, useState } from 'react';
import { formatAsYouType, formatPhone, phoneCountryName } from '../../lib/phone';

// BL-177 Step 2d (section 3): the one phone field. Formats as you type by country (+1 (404) 594-2667,
// +49 163 5959331, +44 20 7946 0958) and hands back E.164 once the number is complete and valid.
//
//   value     - the stored value (E.164, or whatever legacy text is there). Shown formatted.
//   onChange  - called with the E.164 string when valid, otherwise the raw typed text (so a half-typed number
//               is never silently dropped, and nothing but a valid E.164 should be treated as "saved").
//   onValidityChange(valid, e164) - optional, for forms that gate Save.
//   defaultCountry - used for numbers typed without a leading "+" (default US).
export default function PhoneInput({ value, onChange, onValidityChange, defaultCountry = 'US', showCountry = false, id, className = '', placeholder, 'aria-label': ariaLabel, disabled = false, required = false, name }) {
    const [text, setText] = useState(() => formatPhone(value, defaultCountry));
    const [last, setLast] = useState(value || '');
    useEffect(() => {
        // Re-sync only when the parent changes the value to something we did not just emit.
        if ((value || '') !== last) { setText(formatPhone(value, defaultCountry)); setLast(value || ''); }
    }, [value, last, defaultCountry]);
    const parsed = formatAsYouType(text, defaultCountry);
    const incomplete = text.trim() !== '' && !parsed.valid;
    return (
        <span className="block">
            <input
                type="tel"
                inputMode="tel"
                autoComplete="tel"
                id={id}
                name={name}
                aria-label={ariaLabel}
                aria-invalid={incomplete || undefined}
                className={className}
                placeholder={placeholder || '+1 (404) 555-1234'}
                value={text}
                disabled={disabled}
                required={required}
                onChange={(event) => {
                    const next = formatAsYouType(event.target.value, defaultCountry);
                    setText(next.text);
                    const emitted = next.e164 || next.text.trim();
                    setLast(emitted);
                    if (onChange) onChange(emitted);
                    if (onValidityChange) onValidityChange(next.valid, next.e164);
                }}
            />
            {showCountry && parsed.valid && <span className="mt-0.5 block text-xs opacity-80">{phoneCountryName(parsed.e164)}</span>}
            {incomplete && <span role="note" className="mt-0.5 block text-xs opacity-80">Keep typing: include the country code for numbers outside the US.</span>}
        </span>
    );
}
